module.exports = __webpack_public_path__ + "img/buy.e88cc516.png";